import { render, staticRenderFns } from "./koselugo-tabs.vue?vue&type=template&id=7ff6c634&scoped=true"
import script from "./koselugo-tabs.vue?vue&type=script&lang=js"
export * from "./koselugo-tabs.vue?vue&type=script&lang=js"
import style0 from "./koselugo-tabs.vue?vue&type=style&index=0&id=7ff6c634&prod&lang=scss&scoped=true"
import style1 from "./koselugo-tabs.vue?vue&type=style&index=1&id=7ff6c634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff6c634",
  null
  
)

export default component.exports